<template>
  <section class="w-100">
    <article class="col-12 justify-content-center align-items-center" v-if="!isUser">
      <button type="button" class="bg-info w-100 py-3"
              style="font-size: 1.8rem; border-radius: 2.4rem; border: 3px solid black;"
              data-toggle="modal"
              data-target="#customerData">
        {{ idioma.btnRegistrado }}

      </button>
    </article>
    <article class="col-12" v-else>
      <!--      <h3 class="text-center texto-destacado">¡¡{{idioma.saludo}} {{getCustomer().name}} {{getCustomer().surname}}!!</h3>
            <p class="text-center"><small>{{idioma.info}}</small></p>-->
      <button type="button" class="bg-danger w-100 py-3"
              style="font-size: 1.2rem; border-radius: 2.4rem; border: 3px solid black;"
              data-toggle="modal"
              data-target="#cancelar"> {{ idioma.btnSalir }}
      </button>
    </article>
    <!-- Modal -->
    <div class="modal fade" id="customerData" tabindex="-1" role="dialog"
         aria-labelledby="customerDataTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalCenterTitle">{{ idioma.modal.titulo }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <form>
                <div class="form-group">
                  <label for="recipient-name" class="col-form-label">{{ idioma.modal.usuario }}:
                    <input type="text" class="form-control" id="user" v-model="login.userLogin"
                           @keypress="chkUser"
                           ref="user"
                    >
                  </label>
                </div>
                <div class="form-group">
                  <label for="message-text" class="col-form-label">{{ idioma.modal.password }}:
                    <input type="password" class="form-control" id="password"
                           @keypress="chkPassword"
                           v-model="login.userPassword"
                           ref="password"
                    />
                  </label>
                </div>
                <div class="d-flex flex-column justify-content-center align-items-center">
                  <span v-if="showError">
                  <small class="text-white bg-danger p-2 rounded rounded-3" style="opacity: .3">
                    {{ idioma.modal.error }}
                  </small>
                </span>
                  <span>
                    <a href="https://alberguesyrefugios.com/recuperar" target="_blank">
                      <small>{{ idioma.modal.olvido }}</small>
                    </a>
                </span>
                </div>
              </form>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ idioma.modal.btnCancelar }}</button>
            <button type="button" @click="identificarse" class="btn btn-primary">
              {{ idioma.modal.btnAceptar }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <ModalsController :idioma="idioma" @cancelar="salir" modal="cancelar"/>
  </section>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import { customerService } from '../../_services'
import { customerHelper } from '../../_helpers'
import ModalsController from '../modals/ModalsController'

export default {
  name: 'CustomerLogin',
  props: ['idioma', 'isUser'],
  data () {
    return {
      login: {
        userLogin: '',
        userPassword: ''
      },
      showError: false
    }
  },
  mounted () {
    $('#customerData').on('shown.bs.modal', function () {
      $('#user').focus()
    })
  },
  methods: {
    ...mapGetters(['getCustomer']),
    ...mapMutations(['setToken', 'setCustomer']),
    identificarse () {
      customerService.loginAction({
        user: this.login.userLogin,
        password: this.login.userPassword
      }).then(response => {
        if (response.data.response) {
          this.setToken(response.data.result.token)
          customerHelper.setCookie(response.data.result.token)
          customerService.checkToken(response.data.result.token).then(response => {
            this.setCustomer(customerHelper.toForm(response.data.result))
            this.$emit('loginSuccess')
            $('#customerData').modal('hide')

          })
          /*customerService.getLoggedUserInfo().then(data => {
            if (data.response) {
              this.setCustomer(customerHelper.toForm(data.result))
              this.$emit('loginSuccess')
              $('#customerData').modal('hide')
            } else {
              console.log(data)
            }

          })*/

        } else {
          this.showError = true
        }
      })
    },
    chkUser (ev) {
      if (ev.key === 'Enter') this.$refs['password'].focus()
    },
    chkPassword (ev) {
      if (ev.key === 'Enter') this.identificarse()
    },
    salir () {
      // Cancelar toda la reserva y borrar la cookie
      customerService.logoutAction().then(() => {
        customerHelper.setCookie('', true)
        this.setToken('')
        this.$emit('getOut')
      })
    }
  },
  components: {
    ModalsController
  }
}
</script>



// WEBPACK FOOTER //
// src/components/login/CustomerLogin.vue